/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,
  
} from '@thd-olt-component-react/fusion-utils';







  import { PIPRedirector }
    from "@thd-nucleus/app-render";
  
  export { PIPRedirector }

  import { ProductEntryMetadata }
    from "@thd-olt-component-react/metadata";
  
  export { ProductEntryMetadata }

  import { PIPSharebelt }
    from "@thd-olt-component-react/product-details";
  
  export { PIPSharebelt }

  import { MediaGalleryWithHotspotsCarousel }
    from "@thd-olt-component-react/media-gallery";
  
  export { MediaGalleryWithHotspotsCarousel }

  import { PEPProductDetails }
    from "@thd-olt-component-react/product-details";
  
  export { PEPProductDetails }

  import { AisleBay }
    from "@thd-olt-component-react/aisle-bay";
  
  export { AisleBay }

  import { SalientPoints }
    from "@thd-olt-component-react/salient-points";
  
  export { SalientPoints }

  import { SuperSku }
    from "@thd-olt-component-react/super-sku";
  
  export { SuperSku }

  import { OrderSample }
    from "@thd-olt-component-react/order-sample";
  
  export { OrderSample }

  import { PIPPriceClearanceWrapper }
    from "@thd-olt-component-react/price";
  
  export { PIPPriceClearanceWrapper }

  import { Promotion }
    from "@thd-olt-component-react/promotion";
  
  export { Promotion }

  import { BuyboxWithPIPCalculator }
    from "@thd-olt-component-react/buybox";
  
  export { BuyboxWithPIPCalculator }

  import { PEPViewProductDetail }
    from "@thd-olt-component-react/product-details";
  
  export { PEPViewProductDetail }

  import { RoomVoInspire }
    from "@thd-olt-component-react/augmented-reality";
  
  export { RoomVoInspire }

  import { DynamicRecsWrapper }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { DynamicRecsWrapper }

  import { Breadcrumbs }
    from "@thd-olt-component-react/breadcrumbs";
  
  export { Breadcrumbs }

  import { PLPResultsHeader }
    from "@thd-olt-component-react/product-results";
  
  export { PLPResultsHeader }

  import { ResultsAppliedComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsAppliedComposable }

  import { ResultsFilterAndSortDrawerComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsFilterAndSortDrawerComposable }

  import { ResultsDimensionsComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsDimensionsComposable }

  import { ResultsSortByComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsSortByComposable }

  import { DefaultGridComposable }
    from "@thd-olt-component-react/plp-grid";
  
  export { DefaultGridComposable }

  import { ResultsPaginationComposable }
    from "@thd-olt-component-react/product-results";
  
  export { ResultsPaginationComposable }

  import { SearchFeedback }
    from "@thd-olt-component-react/search-feedback";
  
  export { SearchFeedback }

  import { HdhomeSignup }
    from "@thd-olt-component-react/email-signup";
  
  export { HdhomeSignup }

  import { RetailMediaCarouselFusionComposable }
    from "@thd-olt-component-react/retail-media-pla-sponsored-placements";
  
  export { RetailMediaCarouselFusionComposable }

  import { RecentlyViewedWrapper }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { RecentlyViewedWrapper }








  
    
      
        const SlotA1 = withLayout(
          [
            
              PIPRedirector,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotA2 = withLayout(
          [
            
              ProductEntryMetadata,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotC1 = withLayout(
          [
            
              PIPSharebelt,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotC2 = withLayout(
          [
            
              MediaGalleryWithHotspotsCarousel,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD1 = withLayout(
          [
            
              PEPProductDetails,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD2 = withLayout(
          [
            
              AisleBay,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD3 = withLayout(
          [
            
              SalientPoints,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD4 = withLayout(
          [
            
              SuperSku,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotD5 = withLayout(
          [
            
              OrderSample,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE1 = withLayout(
          [
            
              PIPPriceClearanceWrapper,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE2 = withLayout(
          [
            
              Promotion,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE3 = withLayout(
          [
            
              BuyboxWithPIPCalculator,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotE4 = withLayout(
          [
            
              PEPViewProductDetail,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF1 = withLayout(
          [
            
              RoomVoInspire,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotF2 = withLayout(
          [
            
              DynamicRecsWrapper,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotG1 = withLayout(
          [
            
              Breadcrumbs,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotH1 = withLayout(
          [
            
              PLPResultsHeader,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotI1 = withLayout(
          [
            
              ResultsAppliedComposable,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotI2 = withLayout(
          [
            
              ResultsFilterAndSortDrawerComposable,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotJ1 = withLayout(
          [
            
              ResultsDimensionsComposable,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotK1 = withLayout(
          [
            
              ResultsSortByComposable,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotL1 = withLayout(
          [
            
              ResultsAppliedComposable,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotL2 = withLayout(
          [
            
              DefaultGridComposable,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotL3 = withLayout(
          [
            
              ResultsPaginationComposable,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotL4 = withLayout(
          [
            
              SearchFeedback,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotM1 = withLayout(
          [
            
              HdhomeSignup,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotM2 = withLayout(
          [
            
              RetailMediaCarouselFusionComposable,
            
          ],
          
        );
      
    
  

  
    
      
        const SlotM3 = withLayout(
          [
            
              RecentlyViewedWrapper,
            
          ],
          
        );
      
    
  



const ssr = typeof window === 'undefined';


  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  

  
  



export {
  
  
    
      SlotA1,
    
  
    
      SlotA2,
    
  
    
      SlotC1,
    
  
    
      SlotC2,
    
  
    
      SlotD1,
    
  
    
      SlotD2,
    
  
    
      SlotD3,
    
  
    
      SlotD4,
    
  
    
      SlotD5,
    
  
    
      SlotE1,
    
  
    
      SlotE2,
    
  
    
      SlotE3,
    
  
    
      SlotE4,
    
  
    
      SlotF1,
    
  
    
      SlotF2,
    
  
    
      SlotG1,
    
  
    
      SlotH1,
    
  
    
      SlotI1,
    
  
    
      SlotI2,
    
  
    
      SlotJ1,
    
  
    
      SlotK1,
    
  
    
      SlotL1,
    
  
    
      SlotL2,
    
  
    
      SlotL3,
    
  
    
      SlotL4,
    
  
    
      SlotM1,
    
  
    
      SlotM2,
    
  
    
      SlotM3,
    
  

  
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  
    
  

};